import React, { useState } from "react";
import Slider from "react-slick";
import { MdLocationPin, MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { PiSeatFill } from "react-icons/pi";
import { BsFillFuelPumpFill } from "react-icons/bs";
import BookingForm from "../common/BookingForm";
import { Helmet } from "react-helmet";

const CustomPrevArrow = ({ onClick }) => (
    <button
        className="absolute left-[-10px] sm:left-[-30px] md:left-[-15px] top-1/2 transform -translate-y-1/2 
                   bg-pink-500 text-white p-3 sm:p-4 md:p-3 rounded-full shadow-lg 
                   hover:scale-110 transition z-50"
        onClick={onClick}
    >
        <MdArrowBackIos size={20} />
    </button>
);

const CustomNextArrow = ({ onClick }) => (
    <button
        className="absolute right-[-10px] sm:right-[-30px] md:right-[-15px] top-1/2 transform -translate-y-1/2 
                   bg-pink-500 text-white p-3 sm:p-4 md:p-3 rounded-full shadow-lg 
                   hover:scale-110 transition z-50"
        onClick={onClick}
    >
        <MdArrowForwardIos size={20} />
    </button>
);

const latestData = [
    { id: 0, name: "Swift Dzire", brand: "Maruti", imgUrl: "https://stimg.cardekho.com/images/carexteriorimages/630x420/Maruti/Dzire/11387/1731318279714/front-left-side-47.jpg", price: "11", gps: "GPS", seat: "4", fuel: "Gas" },
    { id: 2, name: "Etios", brand: "Toyota", imgUrl: "https://5.imimg.com/data5/ON/GO/MY-1705300/toyota-etios-car-rental-services.jpg", price: "11", gps: "GPS", seat: "4", fuel: "Gas" },
    { id: 3, name: "Ertiga", brand: "Maruti", imgUrl: "https://www.v3cars.com/media/model-imgs/1655184812-Maruti%20Suzuki%20Ertiga.webp", price: "14", gps: "GPS", seat: "7", fuel: "Gas" },
    { id: 4, name: "Innova Crysta", brand: "Toyota", imgUrl: "https://cdni.autocarindia.com/Utils/ImageResizer.ashx?n=https://cdni.autocarindia.com/ExtraImages/20111217093444_5.jpg&w=700&c=1", price: "18", gps: "GPS", seat: "7", fuel: "Gas" },
    { id: 5, name: "Carens", brand: "KIA", imgUrl: "https://imgd.aeplcdn.com/664x374/n/cw/ec/174325/carens-exterior-left-front-three-quarter.jpeg?isig=0&q=80", price: "15", gps: "GPS", seat: "7", fuel: "Gas" },
    { id: 6, name: "Tempo Traveller", brand: "Force", imgUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFaJY4By0d1mWw9-Nozn9hkwf_bdtYlHpGpw&s", price: "32", gps: "GPS", seat: "20", fuel: "Petrol" }
];

const Latest = () => {
    const [isOpen, setIsOpen] = useState(false);

    const settings = {
        dots: false,
        infinite: true,
        speed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
    };

    return (
        <>
            <Helmet>
                <title>The Best Cab Jaipur – Affordable Taxi, One Way & Outstation Services</title>
                <meta
                    name="description"
                    content="Book reliable and affordable cab services in Jaipur for one-way, round trips, and outstation travel. Explore Rajasthan’s top destinations with our trusted taxi service and tour packages."
                />
                <meta
                    name="keywords"
                    content="Jaipur cab service, one way taxi, round trip taxi, outstation travel, affordable taxi, Rajasthan tours, taxi booking Jaipur"
                />
                <meta name="author" content="The Best Cab Jaipur" />
            </Helmet>
            <div className="container mx-auto px-4 overflow-hidden">
                <div className="text-center mt-8">
                    <h2 className="text-4xl font-bold text-gray-800">Our Fleet & Pricing</h2>
                    <h3 className="text-xl font-semibold text-gray-600 mt-2">
                        Turning Your Journeys into Smooth and Memorable Rides
                    </h3>
                </div>

                <Slider {...settings} className="mt-6">
                    {latestData.map((data) => (
                        <div key={data.id} className="px-1 sm:px-2">
                            <div
                                className="relative flex my-10 flex-col text-gray-700 bg-white shadow-lg hover:shadow-2xl cursor-pointer rounded-xl overflow-hidden transition-transform duration-300 transform mx-1 sm:mx-2"
                                style={{ height: "350px" }}
                            >
                                <div className="relative h-48 w-full overflow-hidden rounded-t-xl">
                                    <img
                                        src={data.imgUrl}
                                        alt={data.name}
                                        className="object-cover w-full h-full transition-transform duration-300 hover:scale-105"
                                    />
                                </div>

                                <div className="p-3 flex flex-col justify-between flex-grow">
                                    <div className="pb-1">
                                        <p className="text-xl font-semibold text-gray-900">{data.name}</p>
                                        <p className="text-gray-600 text-sm">{data.brand}</p>
                                    </div>

                                    <div className="grid grid-cols-3 gap-2 my-2">
                                        <span className="bg-pink-200 text-black flex rounded-md items-center justify-center py-1 px-2">
                                            <MdLocationPin className="text-pink-600 mr-1" size={18} />
                                            {data.gps}
                                        </span>
                                        <span className="bg-pink-200 text-black flex rounded-md items-center justify-center py-1 px-2">
                                            <PiSeatFill className="text-pink-600 mr-1" size={18} />
                                            {data.seat}
                                        </span>
                                        <span className="bg-pink-200 text-black flex rounded-md items-center justify-center py-1 px-2">
                                            <BsFillFuelPumpFill className="text-pink-600 mr-1" size={18} />
                                            {data.fuel}
                                        </span>
                                    </div>

                                    <div className="grid grid-cols-2 gap-4 px-2">
                                        <div className="text-black font-semibold p-2">
                                            ₹ {data.price}/km
                                        </div>
                                        <button
                                            className="mt-4 bg-pink-600 text-white px-4 py-2 rounded-md hover:bg-pink-500 transition"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setIsOpen(true);
                                            }}
                                        >
                                            Let's Book
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
                <BookingForm isOpen={isOpen} setIsOpen={setIsOpen} />
            </div>
        </>
    );
};

export default Latest;